import React from "react";
import { Link } from "react-router-dom";
import { ArrowRight, Zap, Percent, Palette, Trophy } from "lucide-react";
import { Reveal, MaskedLines } from "@/components/Reveal";
import { IMG, TEAM_OFFER } from "@/data/site";
import Seo from "@/components/Seo";

const BENEFITS = [
  { icon: Percent, title: "10 % Teamrabatt", desc: "Ab 15 Paar automatisch – 15 Paar für 134,86 € statt 149,85 €." },
  { icon: Palette, title: "Alle Farben", desc: "Weiß, Neon Lime & Sunset Orange frei kombinierbar." },
  { icon: Trophy, title: "Einheitlicher Auftritt", desc: "Dein ganzes Team mit demselben Premium-Grip." },
  { icon: Zap, title: "Ohne Umwege", desc: "Kein Rabattcode, keine Anfrage – direkt im Warenkorb abgezogen." },
];

export default function Teams() {
  return (
    <div className="bg-ink pt-[70px] md:pt-[84px]">
      <Seo title="Teams & Clubs" description="10 % Teamrabatt ab 15 Paar STARSOX Grip-Socken – automatisch im Warenkorb, Farben frei kombinierbar. Perfekt für Fußballvereine." path="/teams" />
      {/* Hero */}
      <section className="relative h-[60vh] min-h-[440px] overflow-hidden grain">
        <img src={IMG.match} alt="Team auf dem Platz" className="absolute inset-0 h-full w-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-t from-ink via-ink/50 to-ink/40" />
        <div className="relative z-10 h-full container-x flex flex-col justify-end pb-12">
          <p className="overline mb-4">Teams & Clubs</p>
          <MaskedLines start className="font-heading uppercase leading-[0.88]" lineClassName="text-5xl md:text-8xl" lines={["Rüste dein", <span key="t" className="text-gold">Team aus.</span>]} />
        </div>
      </section>

      <section className="container-x py-16 md:py-24">
        <div className="max-w-3xl">
          <Reveal>
            <div className="rounded-3xl border border-gold/30 bg-gradient-to-br from-carbon2 to-ink p-8 md:p-12" data-testid="team-discount-info">
              <p className="overline mb-4">10 % Teamrabatt ab 15 Paar</p>
              <div className="flex items-end gap-4 flex-wrap">
                <span className="font-heading text-6xl md:text-7xl text-gold leading-none">{TEAM_OFFER.price}</span>
                <span className="text-white/40 line-through mb-2">{TEAM_OFFER.regular}</span>
              </div>
              <p className="mt-3 text-white/70">{TEAM_OFFER.pairs} Paar STARSOX Performance Grip Socks · nur {TEAM_OFFER.perPair} / Paar</p>
              <p className="mt-6 text-white/60 leading-relaxed text-lg">
                Statte dein Team mit STARSOX aus. Ab 15 Paar erhältst du automatisch 10 % Rabatt auf deine Bestellung – Farben frei kombinierbar. Kein Rabattcode und keine Anfrage notwendig.
              </p>
              <Link to="/shop" data-testid="teams-order-cta" className="btn-primary mt-8">
                Jetzt Team bestellen <ArrowRight className="w-4 h-4" />
              </Link>
            </div>
          </Reveal>
        </div>

        <div className="mt-10 grid sm:grid-cols-2 gap-4 max-w-4xl">
          {BENEFITS.map((b, i) => {
            const Icon = b.icon;
            return (
              <Reveal key={b.title} delay={i * 0.06}>
                <div className="card-hair p-6 h-full">
                  <Icon className="w-6 h-6 text-gold mb-4" />
                  <h3 className="font-heading text-lg uppercase">{b.title}</h3>
                  <p className="text-white/50 text-sm mt-1.5">{b.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </section>
    </div>
  );
}
